import { downloadAppleWalletPass } from "@redotech/redo-customer-portal-shared/utils/wallet-pass";
import { useTranslation } from "@redotech/redo-i18n";
import { toast } from "@redotech/redo-web/alert";
import { useMutation } from "@tanstack/react-query";

export function useDownloadAppleWalletPass() {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (passUrl: string) => downloadAppleWalletPass({ passUrl }),
    onError: (error) => {
      console.error(error);
      toast(
        t("We couldn't add this pass to {{wallet}}. Please try again.", {
          wallet: "Apple Wallet",
        }),
        { variant: "error" },
      );
    },
  });
}
